import { Navigate } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'
import LoadingSpinner from './LoadingSpinner'

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuthContext()

  if (user) {
    return <>{children}</>
  }

  if (loading) {
    return (
      <LoadingSpinner />
    )
  }

  return <Navigate to="/signin" replace />
}
